import { render, staticRenderFns } from "./TrendingCard.vue?vue&type=template&id=fdf1b62c&"
import script from "./TrendingCard.vue?vue&type=script&lang=js&"
export * from "./TrendingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports